import { type ReactNode } from 'react';
import { FeedList } from './feed-list';

export function ComunicadosPage(): ReactNode {
  return (
    <div className="mx-auto w-full max-w-[42rem] space-y-md py-base">
      <h1 className="font-display text-lg font-bold text-text-primary">
        Comunicados
      </h1>
      <FeedList />
    </div>
  );
}
